import { Trans } from "react-i18next"

import util from "utils/utils"

const ProjectAssignedAssignee = ({ events, ownerIdea, ownerChallenge }) => {
  return (
    <Trans
      i18nKey="notifications.projectAssignedAssignee"
      values={{
        name: util.getEventNames(events),
        idea: ownerIdea?.name || "Deleted",
        challenge: ownerChallenge?.name || "Deleted",
      }}
      components={{ b: <b /> }}
    />
  )
}

export default ProjectAssignedAssignee
